var React = require('react');

function AddedIcon (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"32","height":"32","rx":"16","fill":"#C21B03","key":0}),React.createElement("path",{"d":"M18.4314 20H20.0694V10.662H18.4314V14.484H13.5734V10.662H11.9354V20H13.5734V15.926H18.4314V20Z","fill":"white","key":1})]);
}

AddedIcon.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = AddedIcon;

AddedIcon.default = AddedIcon;
